import * as React from 'react';
import { Helmet } from 'react-helmet';

const FlatfyDomainsLinker = () => (
  <Helmet>
    <link rel="alternate" href="https://flatfy.com/" hrefLang="x-default" />
    <link rel="alternate" hrefLang="hu-HU" href="https://hu.flatfy.com" />
    <link rel="alternate" hrefLang="pl-PL" href="https://flatfy.pl/" />
    <link rel="alternate" hrefLang="ro-RO" href="https://flatfy.ro/" />
    <link rel="alternate" hrefLang="cs-CZ" href="https://flatfy.cz/" />
    <link rel="alternate" hrefLang="tr-TR" href="https://tr.flatfy.com/" />
    <link rel="alternate" hrefLang="bg-BG" href="https://bg.flatfy.com/" />
    <link rel="alternate" hrefLang="et-EE" href="https://flatfy.ee/" />
    <link rel="alternate" hrefLang="ru-UA" href="https://flatfy.ua/" />
  </Helmet>
);

export default FlatfyDomainsLinker;
